import { useParams } from "react-router-dom";
import Button from "../../components/Button";
import { forword } from "../../actions/studensts";
import AlertSuccess from "../../components/AlertSuccess";
import AlertDenger from "../../components/AlertDenger";
import Loading from "../../components/Loading";
import { useState } from "react";

export default function ActionButtonsPending() {
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDengerAlert, setShowDengerAlert] = useState(false);
  const [text, setText] = useState("");
  const [loading3, setLoading3] = useState(false);
  const [loadingAatc, setLoadingAatc] = useState(false);

  const { id } = useParams();

  if (showSuccessAlert || showDengerAlert) {
    setTimeout(function () {
      setShowSuccessAlert(false);
      setShowDengerAlert(false);
      setLoading3(false);
      setLoadingAatc(false);
    }, 2000);
  }

  const handleForwardHold = async () => {
    setLoading3(true);
    const res = await forword(
      id,
      "moe/",
      "delivery_hold",
      JSON.parse(localStorage.getItem("profile"))?.value[0].username,
    );
    if (res.status === 200) {
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setShowDengerAlert(true);
      setText(res.data.ERROR);
    }
  };

  const handleForwardAatcReview = async () => {
    setLoadingAatc(true);
    const res = await forword(
      id,
      "moe/",
      "aatc_review",
      JSON.parse(localStorage.getItem("profile"))?.value[0].username,
    );
    if (res.status === 200) {
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setShowDengerAlert(true);
      setText(res.data.ERROR);
    }
  };

  return (
    <div className="flex flex-wrap justify-between">
      {showSuccessAlert && <AlertSuccess text={text} />}
      {showDengerAlert && <AlertDenger text={text} />}
      <div className="p-2">
        <Button
          color="bg-blue-600 disabled:bg-gray-300"
          onClick={handleForwardAatcReview}
          disabled={loadingAatc}
          text={!loadingAatc ? "Forward to AATC Review" : <Loading />}
        />
      </div>
      <div className="p-2">
        <Button
          color="bg-yellow-600 disabled:bg-gray-300"
          onClick={handleForwardHold}
          disabled={loading3}
          text={!loading3 ? "Forward to Delivery Hold" : <Loading />}
        />
      </div>
    </div>
  );
}
